import { render } from "./UsersSettingsPage.vue?vue&type=template&id=c97a4134&ts=true"
import script from "./UsersSettingsPage.vue?vue&type=script&lang=ts"
export * from "./UsersSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__